import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import {
  DownloadReport,
  Loading,
} from '../../../../../../shared/components/buttons/SearchButton';
import Wrapper from '../../../../../../shared/components/Wrapper';
import { download } from '../../../../../../utils/values';
import SetMonthEnd from './FilterModal/components/SetMonthEnd';
import SetMonthInitial from './FilterModal/components/SetMonthInitial';
import { downloadAnalyticalReportExcel } from './FilterModal/functions';

const validationRedenring = (e, l) => {
  if (e === '' || l === '') {
    return (
      <DownloadReport
        justifyContent="center"
        backgroundColor="#a4a4a4"
        width="136px"
      />
    );
  }
  return <Loading justifyContent="center" width="136px" />;
};

export default function analyticReportCsv({ show, onHide }) {
  const dispatch = useDispatch();
  const [initial, setInitial] = useState('');
  const [end, setEnd] = useState('');
  const [fare, setFareOption] = useState('fiducia');

  function setFare(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    setFareOption(value);
  }

  const analyticReportCsvReportContext = useSelector(
    (reducer: IReducer) => reducer.analyticReportCsvReport
  );

  useEffect(() => {
    if (initial !== '' && end !== '') {
      downloadAnalyticalReportExcel(initial, end, fare, dispatch);
    }
  }, [initial, end, fare, dispatch]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      style={{
        borderRadius: '10px 10px 0px 0px',
        display: 'block',
        maxWidth: '550px',
        margin: 'auto',
        left: '50%',
        transform: 'translate(-50%,0%)',
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header
        style={{
          background: '#125C5B',
          color: '#fff',
          fontStyle: 'normal',
          display: 'flex',
          justifyContent: 'center',
        }}>
        <Modal.Title
          style={{
            fontSize: '22px',
            lineHeight: '26px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
          id="contained-modal-title-vcenter">
          Download do relatório analítico em Excel
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Wrapper.Default isActive flexDirection="row">
          <SetMonthInitial setDate={setInitial} date={initial} />
          <SetMonthEnd setDate={setEnd} date={end} />
          <Wrapper.Default flexDirection="column" isActive>
            <Wrapper.Label>Conta:</Wrapper.Label>
            <Form.Control
              as="select"
              style={{ width: '10.5rem', margin: '0 0.5rem 0 0.25rem' }}
              value={fare}
              onChange={(event) => setFare(event)}>
              <option key={0} value="fiducia">
                {1} - Fidúcia
              </option>
              <option key={1} value="terceiros">
                {2} - Terceiros
              </option>
            </Form.Control>
          </Wrapper.Default>
        </Wrapper.Default>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          border: 'none',
        }}>
        <Wrapper.Button onClick={onHide}>Fechar</Wrapper.Button>
        {analyticReportCsvReportContext.isActive === true &&
        initial !== '' &&
        end !== '' ? (
          <DownloadReport
            onClick={() => {
              download(
                analyticReportCsvReportContext.response.path,
                'Relatório Análitico.csv'
              );
            }}
            justifyContent="center"
            width="136px"
          />
        ) : (
          validationRedenring(initial, end)
        )}
      </Modal.Footer>
    </Modal>
  );
}
